<button [ngClass]="class + ' ' + bStyle" type="{{ type }}" (click)="handleClick()" [disabled]="disabled">
  {{ title }}
  <i class="pi pi {{ icon }}"></i>
</button>
